import { Chip, IconButton } from "@material-ui/core";
import CropFreeIcon from "@material-ui/icons/CropFree";
import { CopyField } from "components/fields/CopyField";
import { envSettings } from "core/EnvSettings";
import React from "react";
import { useTranslate } from "react-admin";
import { isNullUndEmpty } from "utils/general";

import { StoragePlaceChip } from "../../components/StoragePlaceChip";

export const StoragePlaceLink = ({
	pallet,
	terminalId,
	storagePlaces = {},
	setBarcodeTitle,
	setBarcodeValue,
	setBarcodeDialogOpen,
}) => {
	const translate = useTranslate();
	const storage_place_id = pallet.storage_place_id;

	if (isNullUndEmpty(storage_place_id)) {
		return null;
	}

	const storagePlace = storagePlaces[storage_place_id];

	if (!storagePlace) {
		return null;
	}

	const storageUrl = `#/storage-ui?places=[${storage_place_id}]&terminal_id=${terminalId}`;
	return (
		<>
			<StoragePlaceChip storagePlace={storagePlace} pallet={pallet} storageUrl={storageUrl} />
			{setBarcodeTitle && setBarcodeValue && setBarcodeDialogOpen ? (
				<IconButton
					size="small"
					onClick={(e) => {
						e.stopPropagation();
						setBarcodeTitle(`${translate("tab.pallets.storage_place_id")}: ${storagePlace.id}`);
						setBarcodeValue(storagePlace.address);
						setBarcodeDialogOpen(true);
					}}
					style={{ padding: 4 }}
				>
					<CropFreeIcon fontSize="small" />
				</IconButton>
			) : null}
		</>
	);
};

export const StorageLinkChipArea = ({ pallet }) => {
	if (isNullUndEmpty(pallet.area_name) && isNullUndEmpty(pallet.area_id)) {
		return null;
	}

	return (
		<Chip
			size="small"
			label={pallet.area_name || pallet.area_id}
			variant={pallet.is_area_confirmed ? "default" : "outlined"}
			style={pallet.is_area_confirmed ? { backgroundColor: "#196d089f", color: "white" } : {}}
		/>
	);
};

export const StorageLinkChip = (props) =>
	envSettings.REACT_APP_FF_STORAGE_MODULE ? (
		<StoragePlaceLink {...props} />
	) : (
		<StorageLinkChipArea {...props} />
	);

export const CopyableStorageLinkChip = ({ storagePlaces, pallet, ...rest }) => {
	const address = storagePlaces[pallet?.storage_place_id]?.address;
	const chip = <StorageLinkChip pallet={pallet} storagePlaces={storagePlaces} {...rest} />;
	if (address) {
		return (
			<CopyField value={address} copyByIcon iconPosition="right">
				{chip}
			</CopyField>
		);
	}
	return chip;
};
